import type { ReactNode } from 'react';
import { Paper } from '@mui/material';
import { WizardHeader } from '@/features/onboarding/WizardHeader';
import { StandaloneMain } from './StandaloneMain';

const CARD_MAX = 560;

/**
 * A screen outside the shell (TMMAPP-0089): brand bar, skip link, one `main`, and a centred
 * outlined card (max 560). `WizardHeader` hides the account menu when there is no session.
 */
export function StandaloneFrame({ children }: { children: ReactNode }) {
  return (
    <>
      <WizardHeader />
      <StandaloneMain
        maxWidth={false}
        sx={{ maxWidth: CARD_MAX, width: '100%', mx: 'auto', py: 3 }}
      >
        <Paper variant="outlined" sx={{ p: { xs: 3, md: 4 }, width: '100%' }}>
          {children}
        </Paper>
      </StandaloneMain>
    </>
  );
}
